/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Info_Delete_Success_ToastInputs */

const en_explorer_info_delete_success_toast = /** @type {(inputs: Explorer_Info_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" was deleted successfully`)
};

const fr_explorer_info_delete_success_toast = /** @type {(inputs: Explorer_Info_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" supprime avec succes`)
};

const de_explorer_info_delete_success_toast = /** @type {(inputs: Explorer_Info_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" wurde erfolgreich gelöscht`)
};

const it_explorer_info_delete_success_toast = /** @type {(inputs: Explorer_Info_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" è stato eliminato correttamente`)
};

const ru_explorer_info_delete_success_toast = /** @type {(inputs: Explorer_Info_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" был успешно удален`)
};

const es_explorer_info_delete_success_toast = /** @type {(inputs: Explorer_Info_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" se eliminó correctamente`)
};

const zh_cn2_explorer_info_delete_success_toast = /** @type {(inputs: Explorer_Info_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.name}”已成功删除`)
};

const ja_explorer_info_delete_success_toast = /** @type {(inputs: Explorer_Info_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」は正常に削除されました`)
};

const hi_explorer_info_delete_success_toast = /** @type {(inputs: Explorer_Info_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" सफलतापूर्वक हटा दिया गया`)
};

const pt_pt2_explorer_info_delete_success_toast = /** @type {(inputs: Explorer_Info_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" foi excluído com sucesso`)
};

/**
* | output |
* | --- |
* | "\"{name}\" was deleted successfully" |
*
* @param {Explorer_Info_Delete_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_delete_success_toast = /** @type {((inputs: Explorer_Info_Delete_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Delete_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_delete_success_toast(inputs)
	if (locale === "de") return de_explorer_info_delete_success_toast(inputs)
	if (locale === "it") return it_explorer_info_delete_success_toast(inputs)
	if (locale === "ru") return ru_explorer_info_delete_success_toast(inputs)
	if (locale === "es") return es_explorer_info_delete_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_delete_success_toast(inputs)
	if (locale === "ja") return ja_explorer_info_delete_success_toast(inputs)
	if (locale === "hi") return hi_explorer_info_delete_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_delete_success_toast(inputs)
	return en_explorer_info_delete_success_toast(inputs)
});